// extracted by mini-css-extract-plugin
export default {"dialog":"C36iQ9PJ83PpDuVglNUS"};